export const MidmarketCheckout = "MidmarketCheckout"
export const ExpressCheckout = "ExpressCheckout"
export const annualTermLength = 12;
export const standardLicenseTermLength = 36;
export const transactionLimit = 25000;
export const directMonthly = 'Direct Monthly';
export const directAnnual = 'Direct Annual';
export const upfrontPayments = 'Upfront Payments';
export const USD_CREDIT_CARD_LIMIT = 50000;
export const EUR_CREDIT_CARD_LIMIT = 50000;
export const GBP_CREDIT_CARD_LIMIT = 40000;
export const stripeElementPaymentMethods = ["Credit Card", "SEPA", "BACS", "ACH", "ACSS"];
export const nonStripePaymentMethods = ['Invoice']

export const stripeToPaymentMethod={
    'us_bank_account': 'ACH',
    'bacs_debit': 'BACS',
    'acss_debit': 'ACSS',
    'sepa_debit':'SEPA',
    'card': 'Credit Card'
}

export const countryCodeMappings = {
    'United States': 'US',
    'United Kingdom': 'GB',
    'France': 'FR',
    'Canada': 'CA',
    'Belgium': 'BE',
    'Germany': 'DE',
    'Luxembourg': 'LU',
    'Liechtenstein': 'LI',
    'Austria': 'AT',
    'Netherlands': 'NL',
    'Mexico': 'MX',
    'Switzerland': 'CH',
    'Ireland': 'IE',
    'Spain': 'ES',
    'Italy': 'IT',
    'Portugal': 'PT',
}

export const productsWithLicenses = [
    "VG34", "VG54","CM31", "CM32", "CM31-VG54", "CM32-VG54","EM21", "EM22", "AG46",
    "AG46P", "AG26", "DM11", "CRGO", "AG51", "AG52"
]

// Used to display a product as an accessory vs. main product
export const coreProducts = [
    "CamConnector", "VG34", "VG54", "CM31-VG54", "CM32-VG54", "AG46",
    "AG46P", "AG26", "AG51", "AG52"
]

export const productToFamily = {
    "VG54": "VG",
    "VG34": "VG",
    "CM32": "CM",
    "CM31": "CM",
    "CM31-VG54": "CM",
    "CM32-VG54": "CM",
    "AG46P": "AG",
    "AG51": "AG",
    "AG52": "AG",
    "AG26": "AG",
    "ACC-CM3-CVR2": "CM",
}

export const currencyToPaymentMethods = {
    "USD": ["Credit Card", "ACH", "Invoice"],
    "CAD": ["Credit Card", "ACSS", "Invoice"],
    "MXN": ["Credit Card"],
    "EUR": ["Credit Card", "SEPA"],
    "GBP": ["Credit Card", "BACS"],
    "CHF": ["Credit Card"],
}

export const countryCodeToCurrency = {
    'US': "USD", 
    'CA': "CAD",
    'MX' : 'MXN',
    'CH' : 'CHF',
    'GB': 'GBP',
    'FR': 'EUR',
    'BE': 'EUR',
    'DE': 'EUR', 
    'LU': 'EUR', 
    'AT': 'EUR', 
    'NL': 'EUR', 
    'IE': 'EUR',
    'ES': 'EUR',
    'IT': 'EUR',
    'PT': 'EUR',
    'LI': 'CHF',
}


export const cableSelectionRequiredOfferings = {
    "VG54": ["License + Hardware", "Hardware"],
    "VG34": ["License + Hardware", "Hardware"],
    "CM32": ["Standalone License + Hardware", "License + Hardware"],
    "CM31": ["Standalone License + Hardware", "License + Hardware"],
    "CM31-VG54": ["Standalone License + Hardware", "License + Hardware"],
    "CM32-VG54": ["Standalone License + Hardware", "License + Hardware"],
    "AG46P": ["License + Hardware", "Hardware"],
    "AG52": ["License + Hardware", "Hardware"],
    "AG26": ["License + Hardware", "Hardware"],
    "VG-CBL": ["Cable"],
    "AG-CBL": ["Cable"]
}

export const cableSelectionAvailableOptions = {
    "VG54": ["vin", "mmy", "plug type"],
    "VG34": ["vin", "mmy", "plug type"],
    "CM31": ["vin", "mmy", "plug type"],
    "CM32": ["vin", "mmy", "plug type"],
    "CM31-VG54": ["vin", "mmy", "plug type"],
    "CM32-VG54": ["vin", "mmy", "plug type"],
    "AG46P": ["plug type"],
    "AG52": ["plug type"],
    "AG26": ["plug type", "mmy"],
    "VG-CBL": ["vin", "mmy", "plug type"],
    "AG-CBL": ["mmy", "plug type"]
}

export const cloudCableSelectionProductIds = {
    "VG54": 53,
    "VG34": 24,
    "CM31": 24,
    "CM32": 24,
    "CM31-VG54": 53,
    "CM32-VG54": 53,
    "AG46P": 84,
    "AG26": 68,
    "AG-CBL": 68,
    "AG52": 125,
}

export const ag26CableSelectionOptions = {
    "type": "assetType",
    "options": {
        "trailer": {
            "type": "trailerType",
            "options": {
                "dryVan": null,
                "reefer": {
                    "type": "make",
                    "options": {
                        "Thermo King": {
                            "type": "model",
                            "options": {
                                "SB-110": null,
                                "SB-210": null,
                                "SB-310": null,
                                "SB-130": null,
                                "SB-230": null,
                                "SB-330": null,
                                "SL-400E": null,
                                "C-600/C-600M": null,
                                "S-600/S-600M": null,
                                "S-700": null,
                                "S-610M": null,
                                "S-600DE": null,
                                "S-610DE": null,
                                "T-600/T-600R": null,
                                "T-800/T-800R": null,
                                "T-1000/T-1000R": null,
                                "T-680R/T-680S": null,
                                "T-880R/T-880S": null,
                                "T-1080R/T-1080S": null,
                                "T-1080 Spectrum": null,
                                "T-1280R Spectrum": null,
                                "T-590": null,
                                "T-690": null,
                                "T-890": null,
                                "T-1090": null,
                                "T-1090 Spectrum": null,
                                "T-580R": null,
                                "SB-III SR+": null,
                                "SB-III": null,
                                "Other": null,
                            }
                        },
                        "Carrier": {
                            "type": "model",
                            "options": {
                                "X2 2100": null,
                                "X2 2100 APX": null,
                                "X2 2500": null,
                                "X2 2500 APX": null,
                                "X2 1800": null,
                                "X4 7300/7300R": null,
                                "X4 7500/7500R": null,
                                "Vector 6500": null,
                                "Vector 6600": null,
                                "Vector 8500": null,
                                "Vector 8600": null,
                                "Solara Summit": null,
                                "Solara APX": null,
                                "Other": null,
                            }
                        },
                        "Other": null,
                    }
                },
                "other": null
            },
        },

        "poweredEquipment": {
            "type": "diagnosticsCoverage",
            "options": {
                "powerOnly": null,
                "full": {
                    "type": "make",
                    "options": {
                        "Caterpillar": {
                            "type": "year",
                            "options": [...Array(new Date().getFullYear() - 1995 + 1)].map((x, y) => (1995 + y).toString()).reduce((obj, year) => (obj[year]=null, obj),{}),
                        },
                        "John Deere": null,
                        "Other": {
                            "type": "diagnosticsPortType",
                            "options": {
                                "j1939_9Pin": null,
                                "other": null,
                            }
                        }
                    },
                },
            }
        },
    }
}


export const ag26KeysToDisplayValues = {
    "powerOnly": "Engine hours and real-time location only",
    "full": "Full CAN-based engine diagnostics (including engine hours and real-time location)",
    "j1939_9Pin": "Standard J1939 9-pin port",
}

export function determineAGAttributes(row) {
    let availableOptions = ['assetType', 'trailerType', 'diagnosticsCoverage', 'make', 'model', 'year', 'diagnosticsPortType'];
    let options = ['assetType'];
    let agDecisionTree = ag26CableSelectionOptions;
    for (let option of availableOptions) {
        if (row[option]) {
            agDecisionTree = agDecisionTree.options[row[option]];
            if (agDecisionTree) {
                options.push(agDecisionTree.type);
            }
        }
    }
    return options;
}

export function getAGAttributeOptions(row, keyToFind) {
    let keys = determineAGAttributes(row);
    let agDecisionTree = ag26CableSelectionOptions;
    for (let key of keys) {
        if (key === keyToFind) {
            return Object.keys(agDecisionTree.options);
        } else if (row[key]) {
            agDecisionTree = agDecisionTree.options[row[key]];
        } else {
            return [];
        }
    }
    return [];
}
